import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { isEmpty } from 'lodash/lang';
import { trim } from 'lodash/string';
import FinnishSSN from 'finnish-ssn';

import ErrorMessage from '../../components/Messages/ErrorMessage';
import { cyrillicLetterScanner } from '../../util/helpers';

class IdentificationForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allFieldsValid: false,
      firstName: '',
      lastName: '',
      personId: '',
      cyrillicLettersDetected: false,
      firstNameValid: false,
      lastNameValid: false,
      personIdValid: false,
      validationError: '',
      hideLoginError: false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  validateFields() {
    const { firstName, lastName, personId } = this.state;
    const firstNameValid = (firstName.length > 0) && !cyrillicLetterScanner(firstName);
    const lastNameValid = (lastName.length > 0) && !cyrillicLetterScanner(lastName);
    const SSN_SHORT_REGEX = /^([0-2][0-9]|(3)[0-1])(((0)[0-9])|((1)[0-2]))\d{2}$/;
    const personIdValid = this.props.relaxedSotuVerificationEnabled === true ? (FinnishSSN.validate(personId.toUpperCase()) || personId.match(SSN_SHORT_REGEX) != null) : FinnishSSN.validate(personId.toUpperCase());
    const cyrillicLettersDetected = cyrillicLetterScanner(firstName) || cyrillicLetterScanner(lastName) || cyrillicLetterScanner(personId);
    const allFieldsValid = (!cyrillicLettersDetected && firstNameValid && lastNameValid && personIdValid);
    this.setState({
      firstNameValid,
      lastNameValid,
      personIdValid,
      allFieldsValid,
      cyrillicLettersDetected,
      validationError: ''
    });
  }

  handleChange(event) {
    const { id: fieldName, value } = event.target; 

    this.setState({ [fieldName]: trim(value) }, this.validateFields);
    if (this.props.loginFailed) {
      this.setState({ hideLoginError: true });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const { firstName, lastName, personId } = this.state;
    const { requiresEmployer, createUserIfNotExists, relaxedSotuVerificationEnabled } = this.props;
    const formData = Object.assign({ firstName, lastName, personId }, { requiresEmployer, createUserIfNotExists, relaxedSotuVerificationEnabled });
    console.log(formData);
    if (this.state.allFieldsValid) {
      this.props.identifyUser(formData);
      this.setState({ hideLoginError: false });
    } else if (this.state.cyrillicLettersDetected) {
      this.setState({ validationError: 'cyrillicLettersNotAllowed' });
    } else if (!this.state.firstNameValid) {
      this.setState({ validationError: 'firstNameMissing' });
    } else if (!this.state.lastNameValid) {
      this.setState({ validationError: 'lastNameMissing' });
    } else if (!this.state.personIdValid) {
      this.setState({ validationError: 'invalidPersonIdMessage' });
    }
  }

  render() {
    if (this.props.userIdentified) {
      return null;
    }

    const { loginFailed, loginFailedMessage, t } = this.props;

    return (
      <form className="identification-form login-form" onSubmit={e => this.handleSubmit(e)}>
        <div className="form-input-group">
          <input
            id="firstName"
            className={this.state.firstNameValid ? 'is-valid' : ''}
            type="text"
            placeholder={t('identification:identificationForm.firstNamePlaceholder')}
            onChange={this.handleChange}
          />
        </div>
        <div className="form-input-group">
          <input
            id="lastName"
            className={this.state.lastNameValid ? 'is-valid' : ''}
            type="text"
            placeholder={t('identification:identificationForm.lastNamePlaceholder')}
            onChange={this.handleChange}
          />
        </div>
        <div className="form-input-group">
          <input
            id="personId"
            className={this.state.personIdValid ? 'is-valid' : ''}
            type="text"
            placeholder={this.props.relaxedSotuVerificationEnabled ? t('identification:identificationForm.personIdOrBirthdayPlaceholder') : t('identification:identificationForm.personIdPlaceholder')}
            onChange={this.handleChange}
          />
          {this.props.relaxedSotuVerificationEnabled &&
            <div className="date-of-birth-login-format-info"> ({t('identification:identificationForm.personIdRelaxedInfo')})</div>
          }
        </div>
        <ErrorMessage isVisible={!isEmpty(this.state.validationError) || this.state.cyrillicLettersDetected}>
          <strong>{ this.state.cyrillicLettersDetected ? t('cyrillicLettersNotAllowed') : t(this.state.validationError) }</strong>
        </ErrorMessage>
        <ErrorMessage isVisible={loginFailed && !this.state.hideLoginError}>
          <strong>{t('loginFailedTitle')}</strong>
          { loginFailedMessage &&
            <p>{t(loginFailedMessage)}</p>
          }
        </ErrorMessage>
        <Button
          className="action-btn center-block login-button"
          type="submit"
        >
          {t('identification:identificationForm.submitButtonText')}
        </Button>
      </form>
    );
  }
}

IdentificationForm.propTypes = {
  identifyUser: PropTypes.func.isRequired,
  userIdentified: PropTypes.bool.isRequired,
  loginFailed: PropTypes.bool.isRequired,
  loginFailedMessage: PropTypes.string,
  requiresEmployer: PropTypes.bool.isRequired,
  createUserIfNotExists: PropTypes.bool.isRequired,
  relaxedSotuVerificationEnabled: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

IdentificationForm.defaultProps = {
  loginFailedMessage: null
};

export default translate(['common', 'identification'], { wait: true })(IdentificationForm);



// WEBPACK FOOTER //
// ./src/containers/IdentificationForm/IdentificationForm.jsx